export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./boldplay-frame.vue?vue&type=template&id=48d6d8b5"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/boldplay/boldplay-frame.vue?vue&type=template&id=48d6d8b5
// module id = mYh3
// module chunks = 0